/* eslint-disable @department-of-veterans-affairs/prefer-button-component */
import PropTypes from 'prop-types';
import React from 'react';

function DownshiftClear({
  showClearButton,
  onClearClick,
  inputId,
  clearButtonLabel = 'Clear input',
}) {
  if (!showClearButton) {
    return null;
  }
  return (
    <button
      type="button"
      className="input-with-clear-button"
      id={`clear-${inputId}`}
      aria-label={clearButtonLabel}
      onClick={onClearClick}
      data-testid={`${inputId}-clear-button`}
    >
      <va-icon icon="close" size="3" />
    </button>
  );
}

DownshiftClear.propTypes = {
  inputId: PropTypes.string.isRequired,
  onClearClick: PropTypes.func.isRequired,
  clearButtonLabel: PropTypes.string,
  showClearButton: PropTypes.bool,
};

export default DownshiftClear;
